<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-19 03:07:52
 * @LastEditors: Please set LastEditors
 -->

<template>
    <div class="content" v-loading="loading">
        <div class="formArea">
            <el-form ref="form" :model="form" :rules="rules" label-width="160px">
                <el-form-item label="调仓单号:" prop="stock_in_sn">
                    <el-col :span="5">
                        <el-input v-model="form.stock_in_sn" :readonly="is_edit"></el-input>
                    </el-col>
                    <el-col :span='4'>
                        <el-button type="primary" @click="randomCode" v-if='!$route.query.edit'>新建单号</el-button>
                    </el-col>
                </el-form-item>
              
                <el-form-item label="调出仓库:" props='from_warehouse_sn'>
                    <el-select v-model="form.from_warehouse_sn " size="small" :disabled="$route.query.edit"  @change='changWare'>
                        <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                   :value="i.warehouse_sn"  v-if='form.warehouse_sn!=i.warehouse_sn' ></el-option>
                    </el-select>
                </el-form-item>
                <!--     -->
                <el-form-item label="调入仓库:" props='from_warehouse_sn'>
                    <el-select v-model="form.warehouse_sn " size="small" :disabled="$route.query.edit" @change='changWare'>
                        <el-option v-for=" i in stockArray" :key="i.id" :label="i.warehouse_name"
                                   :value="i.warehouse_sn" v-if='i.warehouse_sn!=form.from_warehouse_sn' ></el-option>
                    </el-select>
                </el-form-item>
                 <!-- <el-form-item label="调入仓库:" props='warehouse_sn'>
                    <el-select v-model="form.warehouse_sn "  size="small" :disabled="$route.query.edit"  @change='changWare'>
                  
                        <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                   :value="i.warehouse_sn"  v-if='form.from_warehouse_sn!=i.warehouse_sn || i.warehouse_sn==""'></el-option>
                    </el-select>
                </el-form-item> -->
               
                
           

                <!-- <el-form-item label="发货单位:">
                     <el-select clearable v-model="form.to_type" size="small">
                         <el-option v-for=" i in deliverType" :key="i.id" :label="i.name"
                                    :value="i.id"></el-option>
                     </el-select>
                 </el-form-item>-->
                <el-form-item label="备注:">
                    <el-input v-model="form.remarks"></el-input>

                </el-form-item>
                <el-form-item>
                    <el-col :span="8">
                        <el-button type="primary" @click="addProduct()">添加产品</el-button>
                    </el-col>
                </el-form-item>

            </el-form>
            <!--表格-->
            <el-table
                    ref="multipleTable"
                    :data="tableData"
                    height="250"
                    border
                    stripe
                    style="width: 100%">
               
                <el-table-column
                        v-if="isCodeShow"
                        prop="production_batch"
                        label="生产批次号"
                        width="120"
                        fixed>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        width="120"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_bar_code"
                        width="180"
                        label="产品条码"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_specs"
                        label="产品规格"
                        width="180"
                        show-overflow-tooltip>
                </el-table-column>
               
                <el-table-column
                        prop=""
                        label="订单数量"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if='scope.row.stock_total'>{{scope.row.stock_total}}</span>
                            <span v-if='scope.row.stock_in_num'>{{scope.row.stock_in_num}}</span>

                        </template>
                </el-table-column>
                 <el-table-column
                        prop="real_stock_in_num"
                        label="已调仓数量"
                        show-overflow-tooltip>
                </el-table-column>
              
                <el-table-column
                        prop=""
                        label="操作"
                        width="180"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="edit(scope.$index,scope.row)">修改</el-button>
                        <el-button type="text" size="small" @click="del(scope.row,scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="primary" @click="save('form')" style="margin: 20px">保存</el-button>
        </div>
  
        <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData="getSelectinfo"
        >
        </selectRole>
        <wareProduct 
                v-if="wareProductDialog"
                v-on:handleClose='wareProductDialog = false'
                :wareData='wareData'
                @pushData="getSelectProduct"
        />
         <el-dialog
            title="添加产品"
            :visible="addProductDialog"
            :append-to-body=true
            class='choose'
            width="60%"
             :before-close='handleClose'>
              <el-form ref="form1" :model="form1" label-width="100px"  class="mt20">
                    <el-form-item label="选择调仓产品:">
                      <el-row>
                          <el-col :span='5' > 
                                <el-input v-model="form1.product_sn" readonly clearable style='width:100%'></el-input>
                          </el-col>
                            <el-col :span='1' style="text-align:center">
                                -
                          </el-col>
                           <el-col :span='5'>
                                <el-input v-model="form1.product_name" readonly clearable></el-input>
                          </el-col>
                          <el-col :offset='1' :span='4' v-if='type!=3'>
                        <el-button type="primary" @click="getSelect()">选择</el-button>

                          </el-col>
                      </el-row>
                    </el-form-item>
                    <el-form-item label="生产批次号:" v-if='isCodeShow'>
                        <el-input v-model="form1.production_batch"  readonly clearable></el-input>
                    </el-form-item>
                 

                    <el-form-item label="订单数量:">
                        <el-input  :max="stock_total" v-model="form1.stock_in_num" clearable placeholder=""></el-input>
                    </el-form-item>
                    
                    <el-form-item v-if='form1.real_stock_in_num&&$route.query.edit'>
                        
                        <span>已调仓数量 {{form1.real_stock_in_num}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="saveProduct()">保存</el-button>
                    </el-form-item>
                </el-form>
      </el-dialog>
    </div>

</template>

<script>
    import wareProduct from './wareProduct';
    import selectRole from '@/components/logistics/common/selectRole';

    export default {
        name: "addDeliver",
        data() {
            return {
                wareProductDialog:false,
                wareProduct:false,
                loading:false,
                is_edit:false,
                pageTitle: '添加发货',
                selectRoleDialog: false,//选择门店/经销商
                addProductDialog: false,//添加产品弹窗
                form: {
                    stock_in_sn: '',
          
                    remarks: '',
                },
                productData:{},//产品 数据
                form1:{
            stock_out_sn: '',
                  

         
                    to_type: '',
                    to_sn: '',
                    to_name: '',
                    to_address: '',
                    stock_out_time: '',
                    isgift: '',
                    remarks: '',
                },
                stock_total:0,//最大数量
                rules: {
                   
                    warehouse_sn: [
                        {required: true, message: '调入仓', trigger: 'blur'}
                    ],
                    from_warehouse_sn:[
                        {required: true, message: '调出仓', trigger: 'blur'}

                    ]
                  

                },
                index:'',
                stockArray: '',//仓库数组
                deliverType: [
                    {
                        id: 1,
                        name: '总部'
                    },
                    {
                        id: 2,
                        name: '经销商'
                    },
                    {
                        id: 3,
                        name: '门店'
                    }
                ],//发货单位
                tableData: [],
                editData: {},//新增出库，修改添加产品时的编辑的点击表格行的数据
                type: 0,//判断是编辑还是新增（0常规添加，1表示修改，2表示修改添加，3表示详情时的修改）
                editIndex: -1,//新增出库单编辑但产品信息的时候使用
                stock_out_sn: '',//保存编辑的出库单号
                isCodeShow: true,//控制生产批次号是否显示
                wareData:{}
            }
        },
        methods: {
            //获取基础配置
            getConfigInfo() {
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    console.log(res);
                    if (res.data.production_batch_on_off == 0) {
                        this.isCodeShow = false;

                    } else if (res.data.production_batch_on_off == 1) {
                        this.isCodeShow = true;

                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            /*生成随机发挥单号*/
            randomCode() {
                var randomNum = Math.ceil(Math.random() * 9999);
                if(randomNum<1000){
                 randomNum = Math.ceil(Math.random() * 9999);
                }
                var myDate = new Date();
                var tY = myDate.getFullYear();
                var tM = myDate.getMonth() + 1;
                if (tM >= 1 && tM <= 9) {
                    tM = "0" + tM;
                }
                var tD = myDate.getDate();
                if (tD >= 1 && tD <= 9) {
                    tD = "0" + tD;
                }
        
                    this.$set(this.form,'stock_in_sn','DC' + tY + tM + tD + randomNum)

            },
            //获取选择经销商门店
            getSelectinfo(val) {
                console.log(val);
                if (val.dealer_sn) {
                    this.form.to_sn = val.dealer_sn;
                    this.form.to_name = val.dealer_name;
                    this.form.to_type = 2;//经销商
                    this.form.to_address = val.dealer_address;//经销商
                } else {
                    this.form.to_sn = val.shop_sn;
                    this.form.to_name = val.shop_name;
                    this.form.to_type = 3;//门店
                    this.form.to_address = val.address;//经销商

                }
            },
            //获取选择选择的产品的信息
            getProInfo(val) {
                //console.log(val);
                if (this.$route.query.stock_out_sn) {
                    return;
                }
                this.tableData = val;
                /* if(this.type == 0){
                     val.stock_out_num = 1;//暂时默认出库数量为1
                     this.tableData.push(val);
                 }else if (this.type == 0){
                     this.tableData[this.editIndex].orderNum = val.orderNum;
                 }*/

                /*if (this.tableData.length == 0) {
                    this.tableData.push(val);
                } else {
                    let count = 0;//标志位，避免重复添加
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (val.id == this.tableData[i].id) {
                            this.tableData[i].orderNum = val.orderNum;
                        }else if(count == 0){
                            this.tableData.push(val);
                            count++;
                        }
                    }
                }*/
            },
            //新建随机单号
            random() {
              
            },
            //编辑进入页面请求单产品的列表数据
            getProList() {
                if (this.$route.query.stock_out_sn) {
                    //编辑页面获取产品列表
                    let requestUrl = '/outwarehouses/' + this.$route.query.stock_out_sn + '/products';
                    this.$get('logistics', requestUrl, {}).then(res => {
                        this.tableData = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //获取仓库
            getStock() {
                this.$get('logistics', '/warehouses.all', {
                    lang: ''
                }).then(res => {
                    this.stockArray = res.data;
                    for (var i = 0; i < res.data.length; i++) {
                        if (res.data[i].is_default == 1) {
                            this.form.warehouse_sn = res.data[i].warehouse_sn;
                        }
                    }
                    this.form.warehouse_sn=""
                }).catch(function (error) {
                    console.log(error);
                });
            },
            // 获取 调出仓库
            //确定是否是进入编辑页面
            isEditPage() {
                if (this.$route.query.edit) {
                    this.form.stock_out_sn = this.$route.query.edit;

                    let url = '/allocations/'+this.$route.query.edit
                    this.$get('logistics', url).then(res => {
                        this.form=res.data
                            this.tableData=res.data.products
                       
                    //    res.data.products.forEach(element => {
                    //    });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //添加产品
    
            //修改
            edit(index,data) {
                this.index=index

             
                //如果有参数表示是编辑单产品，此时表示编辑页面的编辑type的值为3
                if (this.$route.query.edit) {
             
                   this.form1=data
                      
                //    this.form1.stock_in_num=data.stock_total
                    
                    this.type = 3;
                    this.addProductDialog = true;
                    return;
                }
                this.form1 = this.tableData[index];
                this.form1.stock_in_num=this.tableData[index].stock_total
                this.type = 1;
                this.addProductDialog = true;
            },
            // 切换仓库  清空产品
            changWare(){
               
                this.tableData=[]
            },
            //删除
            del(row, index) {


                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //先判断是否进入编辑
                    if (this.$route.query.edit) {
                 
                   var url='/allocations/'+row.stock_in_sn+'/products/'+row.id
                        this.$delete('logistics', url, {
                            lang: '',
                            _method: 'delete'
                        }).then(res => {
                            this.tableData=[]
                            this.isEditPage()
                     
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                        return;
                    }else{
                          this.tableData.splice(index, 1);
                    this.$message({
                                
                                message: '删除成功'
                            });
                    }
          
                  

                }).catch(error => {
                  

                });


            },
            // 添加产品
         addProduct(){
             if(!this.form.from_warehouse_sn){
                        this.$message({
                                message: '请先选择调出仓',
                                type: 'warning'
                            });
                 return
             }
             this.type=0
             this.form1={}
             this.addProductDialog=!this.addProductDialog
         },
        //  选择产品
        getSelect(){
            // this.wareData.is_edit=this.$router,query.edit?0:1
            this.form1={}
            this.wareData.from_warehouse_sn =this.form.from_warehouse_sn
            this.wareData.Num=this.form.num
            this.wareProductDialog=!this.wareProductDialog
        },
        // 选择完毕
        getSelectProduct(value){
          
            
            this.productData=value
        
            this.stock_total=value.stock_in_num
       
            this.form1.product_name=value.product_name
            this.form1.production_batch=value.production_batch
            this.form1.product_sn=value.product_sn
        },
          // 数组去重
        Unique(arr, name) {
            var hash = {};
            return arr.reduce(function (item, next) {
                hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
                return item;
            }, []);
            },
        saveProduct(){
            // 修改
           
            if(this.$route.query.edit){
          
                
               if(this.type!=3){
                  
                    var url='/allocations/'+this.form.stock_in_sn+'/products'
                this.$post('logistics',url,{
                    production_batch:this.form1.production_batch?this.form1.production_batch:'',
                    product_sn:this.form1.product_sn,
                    stock_in_num:this.form1.stock_in_num
                }).then(res=>{
                      this.isEditPage()
                     this.addProductDialog = false;
                     this.form1={}
                }).catch(error=>{
                      this.$message({
                                message: error.message,
                                type: 'warning'
                            });
                })
                
                return
               }else{
                  
                   var url='/allocations/'+this.form.stock_in_sn+'/products/'+this.form1.id
                   this.$patch('logistics',url,{
                       _method :'PATCH',
                       stock_in_num:this.form1.stock_in_num
                   }).then(res=>{
                         this.isEditPage()
                        this.addProductDialog = false;
                     this.form1={}
                   }).catch(error=>{
                        this.$message({
                                message: error.message,
                                type: 'warning'
                            });
                   })
                   return;
               }
            }
      
               
                this.productData.stock_total=this.form1.stock_in_num
                this.productData.max_stock_total=this.stock_total
                this.productData.real_stock_in_num=0
                this.addProductDialog=false
                
                if(this.type==0){
                            
                       this.tableData.push(this.productData)
                       if (!this.isCodeShow) {
                          this.tableData=this.Unique(this.tableData,'product_id')

                    } else if (this.isCodeShow) {
                        this.tableData=this.Unique(this.tableData,'production_batch')
                    }
              
                }else{
                    var temp =this.tableData
                    // this.tableData=[]
                    this.$set(temp,this.index,{})
                     
                       
                        this.$set(temp,this.index,this.productData)
                        this.tableData=temp
                        console.log(temp)
                    
                    
                }
                // 
           
        },
            //保存
            save(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.tableData.length < 1) {
                            this.$message({
                                message: '至少添加一件产品记录！',
                                type: 'warning'
                            });
                            return;
                        }
                        //处理数据
                      
                        var product_sn=[]
                        var production_batch=[]
                        var stock_in_num=[]
                        this.tableData.forEach(element => {
                            console.log(element)
                            product_sn.push(element.product_sn)
                            production_batch.push(element.production_batch?element.production_batch:' ')
                            stock_in_num.push(element.stock_total)

                        });
                     

                        this.loading = true;
                        if (this.$route.query.edit) {
                            let url ='/allocations/'+this.$route.query.edit
                         
                            this.$put('logistics', url, {
                                lang: '',
                                _method: 'PUT',
                                remarks:this.form.remarks,
                           
                            }).then(res => {
                                this.loading = false;

                               
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    });
                                    this.$router.go(-1)
                               
                            }).catch(error => {
                                this.loading = false;
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });

                            });
                            return;
                        }
                        //console.log(stockoutArr);
                        this.$post('logistics', '/allocations', {
                            lang: '',
                            ...this.form,
                            product_sn:product_sn,
                            stock_in_num: stock_in_num,
                            production_batch: production_batch
                        }).then(res => {
                            this.loading = false;
                       
                                this.$message({
                                    message: '添加成功',
                                    type: 'success'
                                });
                                this.$router.go(-1)
                        }).catch(error => {
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleClose(){
           
                this.addProductDialog=false
            }
        },

        created() {
            if (this.$route.query.stock_in_sn) {
                this.pageTitle = '修改发货';
                this.is_edit = true;
            }
            this.randomCode();
            this.getStock();
            this.getConfigInfo();
            //确定进入到编辑页面
            this.isEditPage();
            this.getProList();

        },
        components: {
             selectRole,wareProduct
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        .formArea {
            margin: 20px;
        }
    }
/deep/  input{
    max-width:  200px;
}

</style>